<script>
import confirmationModal from "../../components/modals/modal-confirmation.vue";

const ZAPIER_URL = 'https://zapier.com/developer/public-invite/104519/ae94bdae50fcffcac571210642586474/';

export default {
  props: ['premiumGateEnabled'],
  name: "zapierConnections",
  methods: {
    load: async function () {
      let connections = await this.$A.ZapierService.GetAll();


      if (Array.isArray(connections.data)) {
        this.connections = connections.data;
      }
      this.loaded = true;
    },
    deleteItem(id, name) {
      this.toDelete.id = id;
      this.toDelete.name = name;
      this.$bvModal.show("deleteZapierConnection");
    },
    async actuallyDelete() {
      if (this.toDelete.id > 0) {
        await this.$A.ZapierService.DeleteConnection(this.toDelete.id);
        await this.load();
      }
    },
    createNew: function () {
      let win = window.open(ZAPIER_URL, "_blank");
      win.focus();
      // let win = window.open(window.$A.Env.apiHost+'/Zapier/authorize-user?access_token='+window.$A.Auth.apiToken.token, '_blank');
      // win.focus();
    },
    get(object, path, defaultValue) {
      return _.get(object, path, defaultValue);
    },
    onClickPluginHandler(product) {
      window.open(product.link, '_blank');
    }
  },
  mounted: async function () {
    await this.load();
  },
  data() {
    return {
      connections: [],
      loaded: false,
      toDelete: {
        id: 0,
        name: "",
      },
      products: [
        {
          logo: '/img/logo.svg',
          title: 'Ashore for Illustrator & InDesign',
          icons: [
            { src: '/img/adobe-Illustrator.svg', alt: 'Illustrator Logo' },
            { src: '/img/adobe-InDesign.svg', alt: 'InDesign Logo' }
          ],
          link: 'https://exchange.adobe.com/apps/cc/201477/ashore-for-indesign-and-illustrator'
        },
        {
          logo: '/img/logo.svg',
          title: 'Ashore for Photoshop',
          icons: [
            { src: '/img/adobe-Photoshop.svg', alt: 'Photoshop Logo' }
          ],
          link: 'https://exchange.adobe.com/apps/cc/67e7bd11/ashore-for-photoshop'
        }
      ]
    };
  },
  components: {
    confirmationModal,
  },
};
</script>

<template>
  <div class="integrations-stack">
    <!-- API Information moved to setting-apiInformation.vue -->

    <!-- Adobe plugins -->
    <div class="settings-card">
      <div class="card-head">
        <div class="card-head-title">Adobe Plugins</div>
        <div class="card-head-subtitle">Download Ashore on the Adobe Exchange and send proofs without leaving your canvas.</div>
      </div>
      <div class="card-body">
        <div class="plugin-grid">
          <button
              v-for="(product, index) in products"
              :key="index"
              type="button"
              class="plugin-card"
              :class="[{ 'cursor-no-drop': premiumGateEnabled }]"
              @click="!premiumGateEnabled && onClickPluginHandler(product)"
          >
            <img :src="product.logo" :alt="product.title" class="plugin-logo"/>
            <span class="plugin-text">
              <span class="plugin-title">{{ product.title }}</span>
              <span class="plugin-for">
                For
                <img v-for="(icon, i) in product.icons" :key="i" :src="icon.src" :alt="icon.alt" class="plugin-icon"/>
              </span>
            </span>
            <svg class="plugin-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Zapier -->
    <div class="settings-card">
      <div class="card-head">
        <div class="card-head-title">Zapier Integration</div>
        <div class="card-head-subtitle">Connect Ashore to <a class="head-link" href="https://zapier.com" target="_blank">Zapier</a> and automate your proofing workflow with thousands of apps.</div>
      </div>

      <div class="connection-rows" v-show="connections.length > 0">
        <div class="connection-row connection-row-head">
          <span class="connection-col-user">User</span>
          <span class="connection-col-time">Time</span>
          <span class="connection-col-actions"></span>
        </div>
        <div class="connection-row" v-for="connection in connections" :key="connection.id">
          <span class="connection-col-user connection-name">{{ connection.connectionName }}</span>
          <span class="connection-col-time">{{ connection.creationDate }}</span>
          <span class="connection-col-actions">
            <a class="action-link action-danger"
               @click="deleteItem(connection.id, connection.connectionName)">Delete</a>
          </span>
        </div>
      </div>

      <div v-if="loaded && !connections.length" class="list-empty">
        <div class="empty-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 2v6" />
            <path d="M15 2v6" />
            <path d="M12 17v5" />
            <path d="M5 8h14l-1 7a4 4 0 0 1-4 2h-4a4 4 0 0 1-4-2L5 8z" />
          </svg>
        </div>
        <div class="empty-title">No Zapier connections yet</div>
        <div class="empty-text">Connect Ashore to 5,000+ apps — create proofs from new files in Drive, post approvals to Slack, and more.</div>
        <a @click="!premiumGateEnabled && createNew()" class="primary-btn empty-cta" :class="[{ 'cursor-no-drop': premiumGateEnabled }]">Add Connection</a>
      </div>

      <confirmationModal
          v-on:confirmed="actuallyDelete"
          ref="confirmDelete"
          name="deleteZapierConnection"
          confirm-button-text="Delete Zapier Connection"
          question="Are you sure you would like to delete this zapier connection?"
          :body="
        'This will prevent all active zaps from functioning that are using this connection. </br/> </br/> <b>Deleting Connection:</b> ' +
        toDelete.name
      "
      />

      <div class="card-foot">
        <a @click="!premiumGateEnabled && load()" class="secondary-btn" :class="[{ 'cursor-no-drop': premiumGateEnabled }]">Refresh</a>
        <a @click="!premiumGateEnabled && createNew()" class="primary-btn" :class="[{ 'cursor-no-drop': premiumGateEnabled }]">Add Connection</a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.integrations-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.card-head-subtitle {
  margin-top: 1px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
}
.head-link {
  color: #019256;
  font-weight: 600;
}
.head-link:hover {
  color: #017a48;
}
.card-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
}
.card-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  background: #fbfbfc;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 0 0 12px 12px;
}
.field-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 6px;
}

/* Adobe plugins */
.plugin-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.plugin-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.1);
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: border-color 120ms ease, background-color 120ms ease;
}
.plugin-card:hover {
  border-color: rgba(1, 146, 86, 0.4);
  background: rgba(1, 146, 86, 0.02);
}
.plugin-card:hover .plugin-chevron {
  color: #019256;
  transform: translateX(2px);
}
.plugin-logo {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
}
.plugin-text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.plugin-title {
  font-size: 13.5px;
  font-weight: 600;
  color: #111827;
}
.plugin-for {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
}
.plugin-icon {
  width: 20px;
  height: 20px;
}
.plugin-chevron {
  flex-shrink: 0;
  color: #9ca3af;
  transition: color 120ms ease, transform 120ms ease;
}

/* Zapier connection rows */
.connection-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 13px 20px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
}
.connection-row:last-child {
  border-bottom: 0;
}
.connection-row:not(.connection-row-head):hover {
  background: #f9f9fa;
}
.connection-row-head {
  padding: 9px 20px;
  background: #fbfbfc;
}
.connection-row-head span {
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.connection-col-user {
  flex: 1;
  min-width: 0;
}
.connection-col-time {
  width: 220px;
  flex-shrink: 0;
  font-size: 12.5px;
  color: #6b7280;
}
.connection-col-actions {
  width: 70px;
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
}
.connection-name {
  font-size: 13.5px;
  font-weight: 500;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.action-link {
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
}
.action-danger {
  color: #b43643;
}
.action-danger:hover {
  color: #8f2a35;
  text-decoration: none;
}

/* Empty state */
.list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 48px 32px;
}
.empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 999px;
  background: rgba(1, 146, 86, 0.1);
  color: #019256;
  margin-bottom: 14px;
}
.empty-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.01em;
}
.empty-text {
  margin-top: 5px;
  font-size: 12.5px;
  font-weight: 500;
  color: #6b7280;
  line-height: 1.55;
  max-width: 380px;
}
.empty-cta {
  margin-top: 16px;
}

/* Buttons */
.primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  background: #019256;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 120ms ease;
}
.primary-btn:hover {
  background: #017a48;
  color: #fff;
  text-decoration: none;
}
.secondary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 14px;
  background: #fff !important;
  color: #1f2937 !important;
  border: 1px solid rgba(15, 23, 42, 0.12) !important;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: border-color 120ms ease, color 120ms ease;
}
.secondary-btn:hover,
.secondary-btn:focus {
  border-color: #019256 !important;
  color: #019256 !important;
  text-decoration: none;
}
.cursor-no-drop {
  cursor: no-drop !important;
}

@media (max-width: 767px) {
  .plugin-grid {
    grid-template-columns: 1fr;
  }
  .connection-col-time {
    width: auto;
  }
  .connection-row {
    flex-wrap: wrap;
    gap: 8px;
  }
  .connection-col-user {
    flex-basis: 100%;
  }
  .connection-col-actions {
    margin-left: auto;
  }
  .primary-btn,
  .secondary-btn {
    flex: 1;
  }
}
</style>
